const megabite = 1000000;
const kilobyte = 1000;

export const prettifyFileWeight = (size: number) =>
  size < megabite ? `${size / kilobyte} kb` : `${size / megabite} mb`;
